
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tidal-dashboard/servers",
      function () {
        return require("private-next-pages/tidal-dashboard/servers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tidal-dashboard/servers"])
      });
    }
  